import script from "./PassWord.vue?vue&type=script&lang=ts&setup=true"
export * from "./PassWord.vue?vue&type=script&lang=ts&setup=true"

import "./PassWord.vue?vue&type=style&index=0&id=3609c964&scoped=true&lang=css"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3609c964"]])

export default __exports__